import { useTranslation } from '@rhino-project/core/i18n';
import { AuthForm, type AuthFormValues } from '../../components/auth/AuthForm';
import { useForgotPasswordAction } from '@rhino-project/core/queries';
import { NetworkParamError } from '@rhino-project/core/lib';
import { AuthPage, type AuthPageProps } from './AuthPage';
import { useRhinoConfig } from '@rhino-project/core/config';
import {
  Alert,
  AlertContent,
  AlertTitle,
  AlertDescription
} from '@heroui/react';
import { Link } from '@tanstack/react-router';

export const ForgotPasswordPage = (props: AuthPageProps) => {
  const { t } = useTranslation();
  const { appName } = useRhinoConfig();
  const {
    mutate: forgotPasswordAction,
    isPending,
    isSuccess,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    data: { data: { message } = {} } = {} as any,
    error
  } = useForgotPasswordAction();
  const paramError = error as NetworkParamError | null;

  const handleSubmit = (formValues: AuthFormValues) =>
    forgotPasswordAction(formValues);

  return (
    <AuthPage
      title={t('rhino.frontend.messages.reset_your_password')}
      description={t(
        'rhino.frontend.messages.enter_your_email_and_we_ll_send_you_a_reset_link'
      )}
      {...props}
    >
      <AuthForm
        emailField
        primaryAction={t('rhino.frontend.messages.reset_password')}
        isPending={isPending}
        errors={paramError?.errors}
        onSubmit={handleSubmit}
        {...props}
      />

      {isSuccess && (
        <Alert
          status="success"
          className="mt-4 bg-success/10 border border-success/20"
        >
          <AlertContent>
            <AlertTitle>
              {t('rhino.frontend.messages.reset_password')}
            </AlertTitle>
            <AlertDescription>{message}</AlertDescription>
          </AlertContent>
        </Alert>
      )}

      <p className="text-sm text-muted text-center mt-4">
        {t('rhino.frontend.messages.remember_password', { appName })}{' '}
        <Link className="text-accent hover:underline" to="/auth/signin">
          {t('rhino.frontend.messages.sign_in')}
        </Link>
      </p>
    </AuthPage>
  );
};
